<template>

	  <ConfirmDialogue ref="confirmDialogue" />
  	<MessageDialogue ref="messageDialogue" />

  	<inner-template :breadcrumbs="breadcrumbs">

	  	<div class="component-content">
	  		
	  		<!-- Фильтры -->
				<div class="component-filter">
					<div class="component-filter__content">
						<div class="component-filter__item">
							<SelectPicker :list="employees" :label="'Выберите сотрудника'" v-model="filter.employee" :size="'sm'" :isClear="true"/>
						</div>
						<div class="component-filter__item">
							<div class="range-picker">
								<DatePicker v-model="filter.dateFrom" label="Дата от" :isClear="true" size="sm" />
								<DatePicker v-model="filter.dateTo" label="Дата до" :isClear="true" size="sm" />
							</div>
						</div>
						<div class="component-filter__item">
							<SelectPicker :list="actionTypes" :label="'Тип задания'" v-model="filter.actionType" :size="'sm'" :isClear="true"/>
						</div>
						<div class="component-filter__item">
							<SelectPicker :list="modules" :label="'Модуль'" v-model="filter.module" :size="'sm'" :isClear="true"/>
						</div>
						<div class="component-filter__item">
							<SelectPicker :list="epicsDependence" :label="'Группа'" v-model="filter.epic" :size="'sm'" :isClear="true"/>
						</div>
						<div class="component-filter__item">
							<SelectPicker :list="topicsDependence" :label="'Подгруппа'" v-model="filter.topic" :size="'sm'" :isClear="true"/>
						</div>
					</div>
				</div>

	  		<!-- Заголовки колонок -->
				<div class="component-headers" v-if="counter !== null">
					<div class="component-headers__item">
						<div class="component-header component-header--grey">
							<div class="component-header__label">Назначено</div>
							<div class="component-header__group">
								<div class="component-header__badge"> {{ counter.assigned }} </div>
								<div
									class="status" 
									:class="{'selected': isSelectAllAssigned}"
									@click="() => { 
				            isSelectAllAssigned = !isSelectAllAssigned;
			            	tasks.assigned.forEach((task) => {
				            	 if(isSelectAllAssigned) {
				                task.selected = true;
				              } else {
				                task.selected = false;
				              } 
			            	});
			          	}">
								</div>
							</div>
						</div>
					</div>
					<div class="component-headers__item">
						<div class="component-header component-header--grey">
							<div class="component-header__label">Отсрочено</div>
							<div class="component-header__badge"> {{ counter.deferred }} </div>
						</div>
					</div>
					<div class="component-headers__item">
						<div class="component-header component-header--blue">
							<div class="component-header__label">Сделано</div>
							<div class="component-header__badge"> {{ counter.done }} </div>
						</div>
					</div>
					<div class="component-headers__item">
						<div class="component-header component-header--orange">
							<div class="component-header__label">Проблема</div>
							<div class="component-header__badge"> {{ counter.issue }} </div>
						</div>
					</div>
					<div class="component-headers__item">
						<div class="component-header component-header--red">
							<div class="component-header__label">Не сделано</div>
							<div class="component-header__badge"> {{ counter.failed }} </div>
						</div>
					</div>
					<div class="component-headers__item">
						<div class="component-header component-header--darkred">
							<div class="component-header__label">Просрочено</div>
							<div class="component-header__badge"> {{ counter.expired }} </div>
						</div>
					</div>
				</div>


	  		<div class="load-container load" v-if="isLoad"></div>

				<!-- Канбан по задачам -->
	  		<div class="component-tasks" v-if="!isLoad">
	  			<div class="component-tasks__item">
	  				<div class="component-tasks__content" :class="{'fixed': countAssignedSelected > 0}">
	    				<TaskPreview 
	    					v-for="task in tasks.assigned" 
	    					:task="task" 
	    					:organization_id="organization_id" 
	    					:house_id="house_id" 
	    					:key="task.id"
	    					@clickSelect="() => { 
	    						task.selected = !task.selected;
	    						if(!task.selected) {
	    							isSelectAllAssigned = false;
	    						}
	    					}"
	    				/>
	    				<a 
	    					class="btn btn--md btn--outline-dashed btn--inline mt-1" 
	    					@click="uploading($event, 'assigned')" 
	    					v-if="tasks.assigned.length > 0 && maxTaskCategory.indexOf('assigned') == -1">
	    					<div class="btn--text">Показать больше</div>
	    					<div class="btn--loader"></div>
	    				</a>
	  				</div>
	  				<!-- Управление отсрочкой -->
		    			<div class="component-tasks__panel" v-if="countAssignedSelected > 0">
		    				<div class="postponement">
									<CounterPicker :value="postponement" @setValue="(val) => { postponement = val; }" />
					        <a href="javascript:;" class="btn btn--xs btn--outline" :class="{'disabled': postponement == 0}" @click="sendPostponement"> 
					          <div class="btn--text"> Отсрочить ({{ countAssignedSelected }})</div>
					          <div class="btn--loader"></div>
									</a>
								</div>
		    			</div>
	  			</div>

	  			<div class="component-tasks__item">
	  				<div class="component-tasks__content">
	    				<TaskPreview 
	    					v-for="task in tasks.deferred" 
	    					:task="task" 
	    					:organization_id="organization_id" 
	    					:house_id="house_id" 
	    					:key="task.id"
	    				/>
	    				<a 
	    					class="btn btn--md btn--outline-dashed btn--inline mt-1" 
	    					@click="uploading($event, 'deferred')" 
	    					v-if="tasks.deferred.length > 0 && maxTaskCategory.indexOf('deferred') == -1"
	    				>
	    					<div class="btn--text">Показать больше</div>
	    					<div class="btn--loader"></div>
	    				</a>
	  				</div>
	  			</div>

	  			<div class="component-tasks__item">
	  				<div class="component-tasks__content">
	    				<TaskPreview 
	    					v-for="task in tasks.done" 
	    					:task="task" 
	    					:organization_id="organization_id" 
	    					:house_id="house_id"
	    					:key="task.id"
	    				/>
	    				<a 
	    					class="btn btn--md btn--outline-dashed btn--inline mt-1" 
	    					@click="uploading($event, 'done')" 
	    					v-if="tasks.done.length > 0 && maxTaskCategory.indexOf('done') == -1"
	    				>
	    					<div class="btn--text">Показать больше</div>
	    					<div class="btn--loader"></div>
	    				</a>
	    			</div>
	  			</div>
	  			<div class="component-tasks__item">
	  				<div class="component-tasks__content">
	    				<TaskPreview 
	    					v-for="task in tasks.issue" 
	    					:task="task" 
	    					:organization_id="organization_id" 
	    					:house_id="house_id" 
	    					:key="task.id"
	    				/>
	    				<a 
	    					class="btn btn--md btn--outline-dashed btn--inline mt-1" 
	    					@click="uploading($event, 'issue')" 
	    					v-if="tasks.issue.length > 0 && maxTaskCategory.indexOf('issue') == -1"
	    				>
	    					<div class="btn--text">Показать больше</div>
	    					<div class="btn--loader"></div>
	    				</a>
	    			</div>
	  			</div>
	  			<div class="component-tasks__item">
	  				<div class="component-tasks__content">
	    				<TaskPreview 
	    					v-for="task in tasks.failed" 
	    					:task="task" 
	    					:organization_id="organization_id" 
	    					:house_id="house_id" 
	    					:key="task.id"
	    				/>
	    				<a 
	    					class="btn btn--md btn--outline-dashed btn--inline mt-1" 
	    					@click="uploading($event, 'failed')" 
	    					v-if="tasks.failed.length > 0 && maxTaskCategory.indexOf('failed') == -1"
	    				>
	    					<div class="btn--text">Показать больше</div>
	    					<div class="btn--loader"></div>
	  					</a>
	  				</div>
	  			</div>
	  			<div class="component-tasks__item">
	  				<div class="component-tasks__content">
	    				<TaskPreview 
	    					v-for="task in tasks.expired" 
	    					:task="task" 
	    					:organization_id="organization_id" 
	    					:house_id="house_id" 
	    					:key="task.id"
	    				/>
	    				<a 
	    					class="btn btn--md btn--outline-dashed btn--inline mt-1" 
	    					@click="uploading($event, 'expired')" 
	    					v-if="tasks.expired.length > 0 && maxTaskCategory.indexOf('expired') == -1"
	    				>
	    					<div class="btn--text">Показать больше</div>
	    					<div class="btn--loader"></div>
	    				</a>
	  				</div>
	  			</div>    			
	  		</div>
	  	</div>

  	</inner-template>

</template>

<script setup>
  import InnerTemplate from '@/components/tracker/InnerTemplate.vue';
  import SelectPicker from '@/components/ux/SelectPicker.vue';
  import TaskPreview from '@/components/tracker/TaskPreview.vue';
	import DatePicker from '@/components/ux/DatePicker.vue';
  import CounterPicker from '@/components/ux/CounterPicker.vue';

  import ConfirmDialogue from '@/components/modals/ConfirmDialogue.vue';
  import MessageDialogue from '@/components/modals/MessageDialogue.vue';
</script>

<script>

  export default {

    name: 'PageTrackerHouseTasks',

		data: () => ({
      // Страница
      isLoad: true,
      breadcrumbs: [],
      address: null,
      counter: null,

      isSelectAllAssigned: false,
      postponement: 0,

      limit: 10,
      limitPreLoad: 10,
      
      // Справочники
      employees: [],
      tasks: [],
      modules: [],
      epics: [],
      topics: [],
      maxTaskCategory: [],

      actionTypes: [
      	{id: 'review', name: 'Осмотр'},
      	{id: 'work', name: 'Работа'},
      	// {id: 'control', name: 'Контроль'},
      ],

      // Фильтр
      filter: {
      	employee: null,
      	actionType: null,
      	module: null, 
      	epic: null,
      	topic: null,

      	dateFrom: null,
      	dateTo: null,
      },

    }),

    watch: {
    	'filter.employee': function () { this.loadTasks(); },
    	'filter.actionType': function () { this.loadTasks(); },
    	'filter.dateFrom': function () { this.loadTasks(); },
    	'filter.dateTo': function () { this.loadTasks(); },
    	'filter.module': function () {
    		this.filter.epic = null;
    		this.filter.topic = null;
    		this.loadTasks();
    	},
    	'filter.epic': function () {
    		this.filter.topic = null;
    		this.loadTasks();
    	},
    	'filter.topic': function () { this.loadTasks(); },
    },

    computed: {
    	house_id () {
        return this.$route.params.house_id;
      },
    	organization_id () {
        return this.$route.params.organization_id;
      },
      // Фильтруем эпики на лету
      epicsDependence () {
      	let epics = this.epics.slice(0);
      	if (this.filter.module !== null) {
      		for (var i = epics.length - 1; i >= 0; i--) {
      			if(epics[i].module !== this.filter.module) {
      				epics.splice(i, 1);
      			}
      		}
      	}
      	return epics;
      },
      // Фильтруем топики на лету
      topicsDependence () {
      	let topics = this.topics.slice(0);
      	if (this.filter.module !== null) {
      		for (var i = topics.length - 1; i >= 0; i--) {
      			if(topics[i].module !== this.filter.module) {
      				topics.splice(i, 1);
      			}
      		}
      	}
      	if (this.filter.epic !== null) {
      		for (var j = topics.length - 1; j >= 0; j--) {
      			if(topics[j].epic !== this.filter.epic) {
      				topics.splice(j, 1);
      			}
      		}
      	}
      	return topics;
      },
      countAssignedSelected () {
      	let counter = 0;
      	for (const task of this.tasks.assigned) {
      		if (task.selected) {
      			counter++;
      		}
      	}
      	return counter;
      }
    },

    created () {
      Promise.all([ this.loadTasks(), this.loadEmployees(), this.loadModules() ])
	      .then(() => {
	        this.beforeRender();
	        this.isLoad = false;
	      })
	      .catch((e)=> {
	        console.log(e);
	      })
	      .finally(()=> {
	      	// to do все запросы выполненны
	        this.isLoad = false;
	      })
    },

    methods: {
    	
    	beforeRender () {
    		this.breadcrumbs = [
        	{name: this.$route.meta.name, link: this.$route.matched[0].path, ico: this.$route.meta.ico},
        	{name: this.address, link: ''},
        	{name: 'Задания', link: ''},
	      ];
    	},

    	async loadEmployees () {

    		const param = new URLSearchParams({});
	      
	      param.set("companyId", this.organization_id);
	      param.set("house_id", this.house_id);
	      param.set("detailed", true);

  	  	const {data} = await this.axios.get(this.$store.state.api_endpoint + '/employees/?' + param);
        this.employees = data.data;
  	  },
  	  
  	  async loadModules () {
				const r = await this.axios.get(this.$store.state.api_endpoint + '/tracker/' + this.house_id + '/modules');
        this.parseFilterData(r.data.modules);
  	  },

  	  buildFilter () {
        const param = new URLSearchParams({});
        if(this.filter.employee !== null) {
        	param.set("employeeId", this.filter.employee);
        }
        if(this.filter.actionType !== null) {
        	param.set("actionType", this.filter.actionType);
        }
        if(this.filter.module !== null) {
        	param.set("moduleNum", this.filter.module);
        }
        if(this.filter.epic !== null) {
        	param.set("epicNum", this.filter.epic);
        }
        if(this.filter.topic !== null) {
        	param.set("topicNum", this.filter.topic);
        }
        if(this.filter.dateFrom !== null) {
        	param.set("dateFrom", this.filter.dateFrom + 'T00:00:00.000000+00:00');
        }
        if(this.filter.dateTo !== null) {
        	param.set("dateTo", this.filter.dateTo + 'T23:59:59.999999+00:00');
        }

        param.set("taskLimit", this.limit);
        return param;
    	},

  	  async loadTasks () {
	      this.isLoad = true;
        const param = this.buildFilter();
        const { tasks, address, counter } = await this.$store.dispatch('getTrackerTasks', {house_id: this.house_id, data: param});
        this.tasks = tasks;
        this.address = address;
        this.counter = counter;
        this.maxTaskCategory = [];
        for (const type in this.tasks) {
        	if(this.tasks[type].length < this.limit) {
	      		this.maxTaskCategory.push(type);
	        }
	        for (const task of this.tasks[type]) {
	        	task.selected = false;
	        }
        }
	      this.isLoad = false;
    	},

    	async sendPostponement (e) {
    		
    		const btn = e.currentTarget;

    		const isConfirm = await this.$refs.confirmDialogue.show({
          message: 'Вы уверены, что хотите отсрочить выполнение выделенных задач (' + this.countAssignedSelected + ' шт) на ' + this.postponement + ' ' + this.$helpers.num_word(this.postponement, ['день', 'дня', 'дней']) + '?',
          okButton: 'Да',
          cancelButton: 'Нет',
        });

    		if(!isConfirm) { return; }

    		btn.classList.add('btn--load');


    		const taskIds = [];

    		for (const task of this.tasks.assigned) {
      		if (task.selected) {
      			taskIds.push(task.id);
      		}
      	}

  			try {

          await this.axios.post(this.$store.state.api_endpoint + '/tracker/postponing-tasks', {taskIds: taskIds, ttl: this.postponement});

          const msg = 'Срок выполнения задач сдвинут на ' + this.postponement + ' ' + this.$helpers.num_word(this.postponement, ['день', 'дня', 'дней']);

          await new Promise(r => setTimeout(r, 1000));

      		this.$refs.messageDialogue.show({
      			message: msg, 
      			okButton: 'Подтвердить'
      		});

      		this.uploading(null, 'deferred')

          this.postponement = 0;

          for (const task of this.tasks.assigned) {
	      		task.selected = false;
	      	}
	      	this.isSelectAllAssigned = false;

        } catch (e) {

      		this.$refs.messageDialogue.show({message: e.message, okButton: 'Подтвердить'});
        
        }

			  btn.classList.remove('btn--load');

    	},



    	async uploading (e, status) {

    		let btn = null;

    		if(e !== null) {
    			btn = e.currentTarget;
    			btn.classList.add('btn--load');
    		}

        const param = this.buildFilter();

        param.set("status", status);
        param.set("taskLimit", this.limitPreLoad);
        param.set("offset", this.tasks[status].length);

        const { tasks, counter } = await this.$store.dispatch('getTrackerTasks', {house_id: this.house_id, data: param});

        // Добавляем задачи в нужный раздел
        this.tasks[status].push(...tasks[status]);
        // Обновляем счётчики сверху
        this.counter = counter;
        this.isSelectAllAssigned = false;
        // будет ли еще дозагрузка по этой категории?
      	if(tasks[status].length < this.limitPreLoad) {
      		this.maxTaskCategory.push(status);
      	}

    		if(e !== null) {
    			btn.classList.remove('btn--load');
    		}

    	},

  	  parseFilterData (modules) {
  	  	this.modules = [];
  	  	this.epics = [];
  	  	this.topics = [];
  	  	for (let moduleKey in modules) {
  	  		this.modules.push({
  	  			id: moduleKey, 
  	  			name: moduleKey + ' - ' + modules[moduleKey].name,
  	  		});
  	  		for (let epicKey in modules[moduleKey].epics) {
  	  			this.epics.push({
	  	  			id: epicKey, 
	  	  			name: epicKey + ' - ' + modules[moduleKey].epics[epicKey].name,
	  	  			module: moduleKey,
	  	  		});
  	  			for (let topicKey in modules[moduleKey].epics[epicKey].topics) {
  	  				this.topics.push({
		  	  			id: topicKey, 
		  	  			name: topicKey + ' - ' + modules[moduleKey].epics[epicKey].topics[topicKey].name,
		  	  			module: moduleKey,
		  	  			epic: epicKey,
		  	  		});
  	  			}
  	  		} 
  	  	}
  	  },

    },

  }
</script>

<style scoped>


	.postponement {
		display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
	}

	.postponement:deep(.counter) {
		width: 50%;
		min-width: 100px;
	}
	.postponement .btn {
		width: 50%;
	} 




	.component-content {
		display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
	}
	.component-filter {
		background-color: var(--cozh-white);
		padding: 10px 10px;
		border-radius: 8px;
    position: relative;
	}

	.component-filter__content {
		overflow: visible;
		display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
	}

	.component-filter__item {
/*  	flex: 1 1 20%;*/
		min-width: 130px;
    width: auto;
	}
	.component-filter__item:has(.range-picker) {
/*  		flex: 1 1 200px;*/
		min-width: 300px;
		width: 300px;
	}
	.component-filter__item .range-picker {
		width: auto;
	}
	.component-filter__item:deep(.custom-select) {
		height: 34px;
	}
	.component-filter__item:deep(.range-picker .calendar .calendar__control) {
		height: 32px!important;
	}


	.component-tasks {
		display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 5px;
    position: relative;
	}
	.component-tasks__item {
  	flex: 1 1 0;
    width: 0;
    position: relative;
	}
	.component-tasks__content {
    height: calc(100vh - 270px);
    overflow-y: auto;
    padding-right: 5px;
	}
	.component-tasks__content.fixed {
		padding-bottom: 70px;
	}
	.component-tasks__panel {
		position: absolute;
    bottom: 0px;
    left: 0;
    width: calc(100% - 14px);
    padding: 15px;
    background-color: #ffffff;
	}





	.component-headers {
		display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
    position: relative;
	}

	.component-headers__item {
		flex: 1 1 0;
		width: 0;
		padding-right: 4px;
	}

	.component-header {
		background-color: var(--cozh-white);
    border-radius: 8px;
    padding: 7px 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
	}


	.component-header__label {
		color: var(--cozh-grey);
	 	font-size: 11px;
		font-weight: 600;
	 	text-transform: uppercase;
		line-height: 1.3;
	 	letter-spacing: 0.55px;
	 	padding-left: 12px;
	 	position: relative;
	}

	.component-header__label::before {
		content: '';
		height: 5px;
		width: 5px;
		border-radius: 50%;
		position: absolute;
		left: 0px;
		top: 50%;
		transform: translateY(-50%);
	}

	.component-header__badge {
 		font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    padding: 3px 6px;
	}
	.component-header__group {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
	}
	.component-header--grey .component-header__badge,
	.component-header--grey .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-grey);
	}

	.component-header--blue .component-header__badge,
	.component-header--blue .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-blue);
	}

	.component-header--orange .component-header__badge,
	.component-header--orange .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-orange);
	}

	.component-header--red .component-header__badge,
	.component-header--red .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-red);
	}

	.component-header--darkred .component-header__badge,
	.component-header--darkred .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-dark-red);
	}

	.component-header--green .component-header__badge,
	.component-header--green .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-green);
	}



	  .slide-enter-active {
    transition: all 0.2s ease-out;
  }
  .slide-leave-active {
    transition: all 0.2s ease-out;
  }
  .slide-leave-to {
    transform: translateY(30px);
    opacity: 0;
  }
  .slide-enter-from {
    transform: translateY(30px);
    opacity: 0;
  }



</style>